import { object, string } from 'yup';
import { PERSON_NAME } from '../../helpers/constants';

const FamilyCreateSchema = object().shape({
  email: string().email('Enter a valid email').required('Email is required'),
  first_name: string().required('Please enter your First Name').matches(PERSON_NAME, 'Please enter a valid first name'),
  last_name: string().required('Please enter your Last Name').matches(PERSON_NAME, 'Please enter a valid last name'),
  mobile_number: string().required('Please enter your phone number'),
  password: string().min(6, 'Password must contain at least 6 characters').required('Enter your password'),
  location: object().required('Please enter location'),
});

export default FamilyCreateSchema;
